export default __webpack_public_path__ + "static/media/i042vk.df5ca502.webp";